<template>
<div>
    <div class="mobie_box" v-if="windowWidth<=980&&flagipadbool=='0'">
        <el-row>
            <el-col class="mb_col_box">
                <el-row>
                    <el-col :span="12" class="mb_top_left_box">
                        <div class="img_box_mb">
                            <a href="/"><img :src="img_logob" alt="logo"></a> 
                        </div>
                        <div class="img_box_font">
                            <p>{{$t('header.mbleft1')}}</p>
                            <p>{{$t('header.mbleft2')}}</p>
                        </div>
                    </el-col>
                    <el-col :span="12" style="text-align:end">
                        <el-row type="flex" justify="end">
                            <!-- <el-col :span="9" style="margin-top:30px;margin-right:20px;text-align:right">
                                <el-link class="languch_box_mb" @click="changeLanguagemb()" :underline="false">EN / 简</el-link>
                            </el-col> -->
                            <el-col :span="16">
                                <div class="mb_btn_box">
                                    <el-button type="text" v-if="!token" class="mb_btn_bg2" @click="gotoLoginPage">{{$t('header.login')}}</el-button>
                                    <el-button type="text" v-if="!token" class="mb_btn_bg3">|</el-button>
                                    <el-button type="text" v-if="!token" class="mb_btn_bg4" @click="gotoRegisterPage">{{$t('header.register')}}</el-button>
                                    <div v-if="token" class="user_img_box" @click="gotoLoginPage">
                                        <img :src="userPhoto" alt="" class="img-box" />
                                        <el-link style="margin-left:10px" class="languch_box" :underline="false">{{username}}</el-link>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="5" style="margin-top:20px">
                                <div class="mb_menu_box" @click="changeshow"><img src="../../assets/img/mb_menu.png" alt=""></div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-col>
            <el-col style="position:relative">
                <div class="mb_menulist_box">
                    <el-drawer title="menu" :with-header="false" size='60%' :append-to-body='true' :visible.sync="show1" :direction="direction">
                        <el-menu :default-active="activeIndex" @close="handleClose"   class="el-menu-demo" :unique-opened='true' active-text-color='#edeef3;' mode="vertical" @select="handleSelect">
                            <el-submenu v-for="(item,index) in $t('header.menu')" :key="index" :index="index+''">
                                <template slot="title">{{item.name}}</template>
                                <div v-for="(itema,indexa) in item.menuContant" :key="indexa" >
                                    <el-submenu  class="submenu_mb" v-if="itema.tatil!==''" :index="index+'-'+indexa" >
                                        <template slot="title">{{itema.tatil}}</template>
                                        <el-menu-item v-for="(itemc,indexc) in itema.cont" :index="index+'-'+indexa+'-'+indexc" @click="gotopath(item.id,itemc.id)" :key="indexc">{{itemc.name}}</el-menu-item>
                                    </el-submenu>
                                    <el-menu-item v-if="itema.tatil==''" :index="index+'-'+indexa" @click="gotopath(item.id,itema.id)" :key="indexa">{{itema.name}}</el-menu-item>
                                </div>
                            </el-submenu>
                        </el-menu>
                    </el-drawer>
                </div>
            </el-col>
        </el-row>

        <!-- 中英文切换--悬浮 -->
        <div class="mb_lang_box" v-if="menupath == '/'">
            <el-link class="languch_box_mb" @click="changeLanguagemb()" :underline="false">{{mblang}}</el-link>
        </div>


        <!-- <el-row>
            <el-col style="background:red">
                <el-row style="padding:5px 20px 5px 20px;" type="flex" justify="space-between">
                    <el-col :span="6" class="first_col_box">
                        
                    </el-col>
                    <el-col :span="5" style="padding-top:30px;">
                        <el-row>
                            <el-col :span="20">
                                
                            </el-col>
                            <el-col :span="4">
                                <i class="el-icon-search icon_box_mb" v-show="!inputBool" @click="changeInput()"></i>
                                <i class="el-icon-close icon_box_mb" v-show="inputBool" @click="changeInput()"></i>
                                <transition name="el-zoom-in-left">
                                    <div class="ipt_box" v-show="inputBool">
                                        <el-input :placeholder="$t('header.placeholder')" v-model="searchContent" class="input_bg_mb">
                                            <el-button slot="append" icon="el-icon-search"></el-button>
                                        </el-input>
                                    </div>
                                </transition>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-col>
        </el-row> -->
    </div>
    

    <div class='header_ani_ipad' v-else-if="windowWidth<=1400&&flagipadbool=='1'">
        <div class="header_box_ipad">
                <el-row>
                    <el-col :span="24">
                        <el-row type="flex">
                            <el-col :span="24" style="width:100%">
                                <el-row>
                                    <el-col :span="15">
                                        <el-row style="padding-left:20px;">
                                            <el-col :span="5" class="first_col_box" style="text-align:right">
                                                <div class="img_box_ipad">
                                                    <a href="/"><img src="../../assets/img/new_logo_ipad.png" style="width:95px" alt="logo"></a>
                                                </div>
                                            </el-col>
                                            <el-col :span="15" class="img_border_ipad">
                                                <div class="line_box_ipad" v-for="(item,index) in $t('header.leftMenu')" :key="index">
                                                    <el-link :underline="false" href='/'>{{item.name}}</el-link>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="6" class="col_pd" style="text-align:right;padding-top:10px">
                                        <el-button class="btn_box btn_bg1" v-if="!token" @click="gotoLoginPage">{{$t('header.login')}}</el-button>
                                        <el-button class="btn_box btn_bg2" v-if="!token" @click="gotoRegisterPage">{{$t('header.register')}}</el-button>
                                        <div v-if="token" class="user_img_box" @click="gotoLoginPage">
                                            <img :src="userPhoto" alt="" class="img-box" />
                                            <el-link style="margin-left:10px" class="languch_box" :underline="false">{{username}}</el-link>
                                        </div>
                                    </el-col>
                                    <el-col :span="3" style="text-align:left;padding-top:10px">
                                        <el-row>
                                            <el-col style="margin-left:45px">
                                                <el-link class="languch_box" @click="changeLanguage()" :underline="false">EN / 简</el-link>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="24" class="el-row-box" style="width:100%">
                                <el-row class="menu_list_box_ipad" >
                                    <el-col class="colMenu_box" style="text-align:right;" :span="3" @mouseover.native="changemenu(1)" @mouseleave.native="changemenuleve(1)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[0].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box_ipad" :style="{width:windowWidth+'px'}" v-if="menu1">
                                                <div class="list_box_ipad">
                                                    <Menu @childvalue="childvalue" :value = "$t('header.menu[0]')" :num='1'/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:right;" :span="3" @mouseover.native="changemenu(2)" @mouseleave.native="changemenuleve(2)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[1].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box_ipad" :style="{width:windowWidth+'px'}" v-if="menu2">
                                                <div class="list_box_ipad">
                                                    <Menu @childvalue="childvalue" :value = "$t('header.menu[1]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:right;" :span="4" @mouseover.native="changemenu(3)" @mouseleave.native="changemenuleve(3)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[2].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box_ipad" :style="{width:windowWidth+'px'}" v-if="menu3">
                                                <div class="list_box_ipad">
                                                    <Menu @childvalue="childvalue" :value = "$t('header.menu[2]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:center;" :span="5" @mouseover.native="changemenu(4)" @mouseleave.native="changemenuleve(4)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[3].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box_ipad" :style="{width:windowWidth+'px'}" v-if="menu4">
                                                <div class="list_box_ipad">
                                                    <Menu @childvalue="childvalue" :value = "$t('header.menu[3]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:center;" :span="5" @mouseover.native="changemenu(5)" @mouseleave.native="changemenuleve(5)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[4].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box_ipad" :style="{width:windowWidth+'px'}" v-if="menu5">
                                                <div class="list_box_ipad">
                                                    <Menus @childvalue="childvalue" :list="arrlist" :value = "$t('header.menu[4]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:right;" :span="2" @mouseover.native="changemenu(6)" @mouseleave.native="changemenuleve(6)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[5].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box_ipad" :style="{width:windowWidth+'px'}" v-if="menu6">
                                                <div class="list_box_ipad">
                                                    <Menu @childvalue="childvalue" :value = "$t('header.menu[5]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
        </div>
    </div>

    <div class='header' :class="ani=='1'?'header_ani':''" v-else>
        <div class="header_box">
                <el-row>
                    <el-col :span="5">
                        <el-row>
                            <el-col v-if='windowWidth>=1300' :span="9" class="first_col_box" >
                                <div class="img_box">
                                   <a href="/"><img :src="img_logo" alt="logo"></a> 
                                </div>
                            </el-col>
                            <el-col v-else :span="11" class="first_col_box" >
                                <div class="img_box">
                                   <a href="/"><img :src="img_logo" alt="logo"></a> 
                                </div>
                            </el-col>
                            <el-col :span="12" class="img_border">
                                <div class="line_box" v-for="(item,index) in $t('header.leftMenu')" :key="index">
                                    <el-link :underline="false" href='/'>{{item.name}}</el-link>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="19">
                        <el-row type="flex">
                            <el-col :span="12" style="width:100%">
                                <el-row>
                                    <el-col :span="16"><div class="grid-content"></div></el-col>
                                    <el-col :span="6" class="col_pd" style="text-align:right;">
                                        <el-button class="btn_box btn_bg1" @click="gotoLoginPage" v-if="!token">{{$t('header.login')}}</el-button>
                                        <el-button class="btn_box btn_bg2" @click="gotoRegisterPage" v-if="!token">{{$t('header.register')}}</el-button>
                                        <div v-if="token" class="user_img_box" @click="gotoLoginPage">
                                            <img :src="userPhoto" alt="" class="img-box" />
                                            <el-link style="margin-left:10px" class="languch_box" :underline="false">{{username}}</el-link>
                                        </div>
                                        
                                    </el-col>
                                    <el-col :span="2" style="text-align:left;">
                                        <el-row>
                                            <el-col style="margin-left:20px">
                                                <el-link class="languch_box" @click="changeLanguage()" :underline="false">EN / 简</el-link>
                                            </el-col>
                                            <!-- <el-col :span="10">
                                                <i class="el-icon-search icon_box" v-show="!inputBool" @click="changeInput()"></i>
                                                <i class="el-icon-close icon_box" v-show="inputBool" @click="changeInput()"></i>
                                                <transition name="el-zoom-in-left">
                                                    <div class="ipt_box" v-show="inputBool">
                                                        <el-input :placeholder="$t('header.placeholder')" v-model="searchContent" class="input_bg">
                                                            <el-button slot="append" icon="el-icon-search"></el-button>
                                                        </el-input>
                                                    </div>
                                                </transition>
                                            </el-col> -->
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="14" class="el-row-box" style="width:100%">
                                <el-row class="menu_list_box" >
                                    <el-col class="colMenu_box" style="text-align:right;" :span="3" @mouseover.native="changemenu(1)" @mouseleave.native="changemenuleve(1)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[0].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box" :style="{width:windowWidth+'px'}" v-if="menu1">
                                                <div class="list_box">
                                                    <Menu :value = "$t('header.menu[0]')"  :num='1'/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:right;" :span="3" @mouseover.native="changemenu(2)" @mouseleave.native="changemenuleve(2)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[1].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box" :style="{width:windowWidth+'px'}" v-if="menu2">
                                                <div class="list_box">
                                                    <Menu :value = "$t('header.menu[1]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:right;" :span="4" @mouseover.native="changemenu(3)" @mouseleave.native="changemenuleve(3)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[2].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box" :style="{width:windowWidth+'px'}" v-if="menu3">
                                                <div class="list_box">
                                                    <Menu :value = "$t('header.menu[2]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:center;" :span="5" @mouseover.native="changemenu(4)" @mouseleave.native="changemenuleve(4)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[3].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box" :style="{width:windowWidth+'px'}" v-if="menu4">
                                                <div class="list_box">
                                                    <Menu :value = "$t('header.menu[3]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:center;" :span="5" @mouseover.native="changemenu(5)" @mouseleave.native="changemenuleve(5)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[4].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box" :style="{width:windowWidth+'px'}" v-if="menu5">
                                                <div class="list_box">
                                                    <Menus :list="arrlist" :value = "$t('header.menu[4]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                    <el-col class="colMenu_box" style="text-align:right;" :span="2" @mouseover.native="changemenu(6)" @mouseleave.native="changemenuleve(6)">
                                        <el-link :underline="false" >
                                            {{$t('header.menu[5].name')}}
                                            <i class="el-icon-arrow-down"></i>
                                        </el-link>
                                        <transition name="el-zoom-in-top">
                                            <div class="menuct_box" :style="{width:windowWidth+'px'}" v-if="menu6">
                                                <div class="list_box">
                                                    <Menu :value = "$t('header.menu[5]')"/>
                                                </div>
                                            </div>
                                        </transition>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
        </div>
    </div>
</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Menu from './menu.vue'
import Menus from './menu_report.vue'
import report from '@/api/report.js'
import management from '@/api/management.js'
import authority from '@/api/authority'
import sso from '@/api/sso'
import { mapState, mapActions } from "vuex";
import { getDefaultStartTime, formatDates } from "@/util/date";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {Menu,Menus},
  props: {
    widthmun: {
      type: Number,
    },
  },
//   inject: ['reload'], 
  data () {
  // 这里存放数据
    return {
        img_logo:require('@/assets/img/new_logo_web.png'),
        img_logob:require('@/assets/img/new_logo_phone.png'),
        userPhoto: require("../../assets/img/weidenglu-touxiang-copy.png"),
        activeIndex: '0',
        lang:this.$i18n.locale,
        arrlist:[],
        ani:'0',
        isCollapse: true,
        direction: 'ltr',
        show1:false,
        menu1:false,
        menu2:false,
        menu3:false,
        menu4:false,
        menu5:false,
        menu6:false,
        searchContent:'',
        inputBool:false,
        mblang:'EN',
        menupath:'',
        flag:'',
        flagipad:'',
        flagipadbool:'',
        token:'',
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
        windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
    }
  },
  // 监听属性 类似于data概念
  computed: {
  },
  // 监控data中的数据变化
  watch: {
      windowHeight (val) {
        let that = this;
      },
      widthmun (val) {
        this.windowWidth = val;
        if(this.windowWidth<=980){
            this.flagipadbool = '0'
        }
        // this.reload()
        // console.log('宽',val,this.flagipadbool)
      },
      '$i18n.locale'(val) {
        this.lang = val
        this.getActiveList()
       },
  },
  // 方法集合
  methods: {
      formatDates: function (dataVal) {
      if (null == dataVal) {
        return "";
      }
      return formatDates(dataVal);
    },
      getActiveList(){
        let data = {'debug':2}
        if(window.location.origin.indexOf('mock') != -1){
            data = {'debug':1}
        }
        
        report.getActiveList(response => {
            if(response.list && response.list.length >= 0){
                this.arrlist = response.list
                
                if(this.windowWidth<=980&&this.flagipadbool=='0'){
                    this.$t('header.menu')[4].menuContant[0].cont = []
                    this.$t('header.menu')[4].menuContant[1].cont = []
                    for(let i = 0 ; i < this.arrlist.length ; i++){
                        if(this.arrlist[i].categoryId == 1){
                            if(this.lang == 'en-US'){
                                this.$t('header.menu')[4].menuContant[1].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleEn})
                            }else{
                                this.$t('header.menu')[4].menuContant[1].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleZh})
                            }
                        }else{
                            
                            if(this.lang == 'en-US'){
                                this.$t('header.menu')[4].menuContant[0].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleEn})
                            }else{
                                this.$t('header.menu')[4].menuContant[0].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleZh})
                            }
                        }
                    }
                }else{
                    this.$t('header.menu')[4].menuContant[0].cont = []
                    this.$t('header.menu')[4].menuContant[1].cont = []
                    for(let i = 0 ; i < this.arrlist.length ; i++){
                        if(this.arrlist[i].categoryId == 1){
                            if(this.lang == 'en-US'){
                                this.$t('header.menu')[4].menuContant[1].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleEn+' - '+this.arrlist[i].releaseDateEn})
                            }else{
                                this.$t('header.menu')[4].menuContant[1].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleZh+' - '+this.formatDates(this.arrlist[i].releaseDateZh)})
                            }
                        }else{
                            
                            if(this.lang == 'en-US'){
                                this.$t('header.menu')[4].menuContant[0].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleEn})
                            }else{
                                this.$t('header.menu')[4].menuContant[0].cont.push({id:this.arrlist[i].id,name:this.arrlist[i].titleZh})
                            }
                        }
                    }
                    if(this.$t('header.menu')[4].menuContant[1].cont.length > 4){
                        this.$t('header.menu')[4].menuContant[1].cont = this.$t('header.menu')[4].menuContant[1].cont.slice(0, 4)
                        if(this.lang == 'en-US'){
                            this.$t('header.menu')[4].menuContant[1].cont.push({id:this.$t('header.menu')[4].menuContant[1].cont[0].id,name:'...More',categoryId:2})
                        }else{
                            this.$t('header.menu')[4].menuContant[1].cont.push({id:this.$t('header.menu')[4].menuContant[1].cont[0].id,name:'...更多',categoryId:2})
                        }
                    }
                    if(this.$t('header.menu')[4].menuContant[0].cont.length > 4){
                        console.log('aaaaaaaaaaaaa',this.$t('header.menu')[4].menuContant[0].cont)
                        this.$t('header.menu')[4].menuContant[0].cont = this.$t('header.menu')[4].menuContant[0].cont.slice(0, 4)
                        if(this.lang == 'en-US'){
                            this.$t('header.menu')[4].menuContant[0].cont.push({id:this.$t('header.menu')[4].menuContant[0].cont[0].id,name:'...More',categoryId:1})
                        }else{
                            this.$t('header.menu')[4].menuContant[0].cont.push({id:this.$t('header.menu')[4].menuContant[0].cont[0].id,name:'...更多',categoryId:1})
                        }
                    }
                    
                }
                this.$emit("getReportList",response.list)
            }
        },data)

        
      },
      getmanglist(){
            let data = {'debug':2}
            if(window.location.origin.indexOf('mock') != -1){
                data = {'debug':1}
            }
            management.getActiveList(response =>{
                if(this.windowWidth<=980&&this.flagipadbool=='0'){
                    if(response.list && response.list.length >= 0){
                        this.$t('header.menu')[5].menuContant[1].cont = []
                        for(let i = 0 ; i < response.list.length ; i++){
                            if(this.lang == 'en-US'){
                                this.$t('header.menu')[5].menuContant[1].cont.push({id:response.list[i].id,name:response.list[i].titleEn})
                            }else{
                                this.$t('header.menu')[5].menuContant[1].cont.push({id:response.list[i].id,name:response.list[i].titleZh})
                            }
                        }
                    }
                }
            },data)
      },
      childvalue(val){
          this.menu1 = val;
          this.menu2 = val;
          this.menu3 = val;
          this.menu4 = val;
          this.menu5 = val;
          this.menu6 = val;
      },
      changeInput(){
          return this.inputBool = !this.inputBool;
      },
      handleSelect(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      },
      mouseMenu(id,row){
         return row.menuBool = !row.menuBool
      },
      changemenu(row){
          if(row == 1){
            return  this.menu1 = true;
          }else if(row == 2){
            return  this.menu2 = true;
          }else if(row == 3){
            return  this.menu3 = true;
          }else if(row == 4){
            return  this.menu4 = true;
          }else if(row == 5){
            return  this.menu5 = true;
          }else if(row == 6){
            return  this.menu6 = true;
          }
      },
      changemenuleve(row){
          if(row == 1){
            return  this.menu1 = false;
          }else if(row == 2){
            return  this.menu2 = false;
          }else if(row == 3){
            return  this.menu3 = false;
          }else if(row == 4){
            return  this.menu4 = false;
          }else if(row == 5){
            return  this.menu5 = false;
          }else if(row == 6){
            return  this.menu6 = false;
          }
      },
      changeLanguage(){
            this.$i18n.locale = this.$i18n.locale == 'zh-CN' ? 'en-US' : 'zh-CN'
            localStorage.setItem('languageSet',this.$i18n.locale)
      },
      changeLanguagemb(){
            this.$i18n.locale = this.$i18n.locale == 'zh-CN' ? 'en-US' : 'zh-CN'
            if(this.$i18n.locale == 'zh-CN'){
                this.mblang = 'EN'
            }else{
                this.mblang = 'CN'
            }
            localStorage.setItem('languageSet',this.$i18n.locale)
      },
      changeshow(){
          this.show1 = !this.show1
      },
      gotoLoginPage(){
            let host = window.location.host
            // console.log(host)
            authority.getLoginUrl(response =>{
                window.location = response.loginUrl
            })
      },
      gotoRegisterPage(){
            let host = window.location.host
            // console.log(host)

            if(host.includes("localhost")== true)
            {
                window.location = "http://localhost:9035/oauth/authorize?response_type=code&scope=user&client_id=portal";
            }
            else if(host.includes("dev")== true)
            {
                if(host.includes("ctx")== true)
                {
                    window.location = "https://register.dev.ctx.com.sg/login";
                }else
                {
                    window.location = "https://register.dev.mvgx.com/login";
                }
            }
            else if(host.includes("test")== true)
            {
                if(host.includes("ctx")== true)
                {
                    window.location = "https://register.test.ctx.com.sg/login";
                }else
                {
                    window.location = "https://register.test.mvgx.com/login";
                }
            }else{
                if(host.includes("ctx")== true)
                {
                    window.location = "https://register.ctx.sg/login";
                }else
                {
                    window.location = "https://register.mvgx.com/login";
                }
            }
      },
      gotopath(row,id){
          this.$bus.$emit('changeid', id)
          if(row == 1){
              this.$router.push({path:'/btc',query: {id:id}})
              this.show1 = !this.show1
          }else if(row == 2){
              this.$router.push({path:'/services',query: {id:id}})
              this.show1 = !this.show1
          }else if(row == 3){
              if(id == '7'){
                  this.$router.push({path:'/nftmarket',query: {id:id}})
              }else{
                  this.$router.push({path:'/markets',query: {id:id}})
              }
              this.show1 = !this.show1
          }else if(row == 4){
              this.$router.push({path:'/regulation',query: {id:id}})
              this.show1 = !this.show1
          }else if(row == 5){
              this.$router.push({path:'/research',query: {id:id}})
              this.show1 = !this.show1
          }else if(row == 6){
              this.$router.push({path:'/about',query: {id:id}})
              this.show1 = !this.show1
          }
        //   window.location.reload();
      },
      showIcon() {
            if (!!document.documentElement.scrollTop && document.documentElement.scrollTop > 100) {            
                // console.log(1,document.documentElement.scrollTop)
                this.ani = 1
            } else {
                // console.log(2,document.documentElement.scrollTop)
                this.ani = 0
            }
      },
      isMobile() {
            this.flagipad = '';
            this.flagipadbool = ''
            this.flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            // console.log(333,this.flag);
            if(this.flag === null) {
                console.log("pc端");
                if(this.windowWidth<=980){
                    this.flagipadbool = '0'
                }else[
                    this.flagipadbool = '1'
                ]
                
            }else {
                this.flagipad =  this.flag[0];
                this.flagipadbool = '0'
                if(this.flagipad == "iPad"){
                    this.flagipadbool = '1'
                    // alert(this.windowWidth+'---'+this.flagipadbool)
                }
                console.log("移动端");
            }
      }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
      this.getActiveList()
      this.getmanglist()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
      
      this.token = authority.getToken()
      this.username = authority.getusername()
      var that = this;
      this.menupath = this.$route.path
        // <!--把window.onresize事件挂在到mounted函数上-->
        this.isMobile();
        window.addEventListener('scroll',function(){
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop>100){//滚动条的高度，可以动态获取也可以写死
                //这里写要执行的操作
                this.ani = 1
            } else {
                // console.log(2,document.documentElement.scrollTop)
                this.ani = 0
            }
        })
        window.addEventListener("scroll", this.showIcon);
        window.onresize = () => {
            return (() => {
              window.fullHeight = document.documentElement.clientHeight;
              window.fullWidth = document.documentElement.clientWidth;
              that.windowHeight = window.fullHeight;  // 高
              that.windowWidth = window.fullWidth; // 宽
            })()
          };
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.header{
    width: 100%;
    height:58px;
    padding:40px 0 20px 0;
    // background: rgba(25, 90, 142, 0.7);
    position: fixed;
    top:0;
    left:0;
    z-index: 1000;
    transition: all 0.7s ease-out;
}
.header_ani{
    width: 100%;
    height:58px;
    padding:20px 0 20px 0;
    background: rgba(25, 90, 142, 0.7);
    position: fixed;
    top:0;
    left:0;
    z-index: 1000;
    transition: all 0.7s ease-out; //过度时间 可调
}
.header_ani_ipad{
    width: 100%;
    height:70px;
    padding:20px 0 40px 0;
    background: rgba(25, 90, 142, 0.7);
    position: fixed;
    top:0;
    left:0;
    z-index: 1000;
    // transition: all 0.7s ease-out; //过度时间 可调
}

.header_box{
    width: 84%;
    margin:0 auto;
    position: relative;
    top:0;
    left:0;
    z-index: 100;
}
.header_box_ipad{
    width: 98%;
    margin:0 auto;
    position: relative;
    top:0;
    left:0;
    z-index: 100;
}

.img_border{
    border-left:1px solid rgba(255,255,255,0.4);
    transform: translateY(-15%);
    padding-left:15px;
}
.img_border_ipad{
    border-left:1px solid rgba(255,255,255,0.4);
    padding-left:15px;
    p{
        font-size: 12px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 18px;
    }
}

.first_col_box{
    margin-right:15px;
    width: auto;
    // padding: 0 20px;
}

.img_box{
    width: 94px;
    transform:translateY(-5%);
}
.img_box_ipad{
    transform: translateY(5px);
    margin-right: 15px;
    margin-bottom:-15px;
}

.line_box{
    display: flex;
    flex-direction: column;
}
.line_box_ipad{
    display: flex;
    flex-direction: column;
    .el-link{
        font-size:12px;
        line-height: 20px;
    }
}

// .col_pd{
    // padding-right:20px;
// }

.btn_box{
    width: 90px;
    height:32px;
    line-height: 7px;
    font-size:14px;
    font-family: ArialMT;
}
.mb_btn_box{
    transform: translateY(20px);
    text-align: center;
    border:1px solid #EAEAEA;
    border-radius: 50px;
    padding:10px;
}

.btn_bg1{
    background: rgba(25, 90, 142, 0.1);
    color: #fff;
}

.btn_bg2{
    color: #000;
}

.ipt_box{
    position: relative;
}

.languch_box{
    color:rgb(255,255,255);
    font-weight: normal;
    font-size:14px;
}

.mb_lang_box{
    width: 80px;
    height: 80px;
    background: #3CB1CE;
    border: 1px solid #3CB1CE;
    border-radius: 50%;
    box-shadow: 0px 4px 18px 0px rgba(33, 123, 160, 0.3);
    opacity: 0.69;
    position: fixed;
    right:10px;
    top:160px;
    z-index: 100;
    
}

.languch_box_mb{
    color:#FFFFFF !important;
    font-weight: 500;
    font-size:30px !important;
    transform: translate(20px,15px);
    line-height: 50px;
    font-family: PingFangSC-Medium, PingFang SC;
}

.icon_box_mb{
    color:#1f2131;
    font-weight: 700;
    font-size:24px;
    padding-top:5px;
    padding-left:5px;
}

.icon_box{
    color:#fff;
    font-weight: 700;
    font-size:20px;
    padding-top:5px;
    padding-left:5px;
}

.input_bg{
    width:300px;
    position: absolute;
    top:-35px;
    right:100%;
}
::v-deep .input_bg_mb{
    width:500px;
    position: absolute;
    top:-40px;
    right:100%;
    .el-input__inner{
        height:50px;
        font-size:x-large;
    }
}

.el-row-box .el-row--flex{
    flex-direction: row;
}

.colMenu_box{
    color:rgb(255,255,255);
    font-weight: normal;
    font-size: 14px;
    text-align: center;
    padding-top:10px;
}

.colMenu_box:hover .el-icon-arrow-down{
    transform-origin:center center; //旋转中心要是正中间 才行
    transform: rotate(180deg);
    transition: transform 0.2s; //过度时间 可调
}

.menuct_box{
    width: 100%;
    height:300px;
    background: #fff;
    position: fixed;
    left:0;
}
.menuct_box_ipad{
    width: 100%;
    height:350px;
    background: #fff;
    position: fixed;
    left:-10px;
}

.list_box{
    width: 60%;
    height:100%;
    margin: 0 auto;
}
.list_box_ipad{
    width: 95%;
    height:100%;
    margin: 0 auto;
}
.user_img_box{
    display: flex;
    justify-content:flex-end;
    align-items: center;
}

.menu_list_box{
    display: flex;
    justify-content: flex-end;
    padding-right:20px;
    .el-col{
        width: auto;
        margin-left:30px;
    }
}
.menu_list_box_ipad{
    display: flex;
    justify-content: space-between;
    transform: translateY(10px);
    .el-col{
        width: auto;
        margin-left:8px;
    }
    .el-link{
        font-size: 14px;
    }
}

::v-deep.list_box .el-row{
    text-align: left;
    display: flex;
    justify-content: center;
}
::v-deep.list_box_ipad .el-row{
    text-align: left;
    display: flex;
    justify-content: center;
}

::v-deep .el-link{
    justify-content: left;
    font-size:14px;
}

::v-deep .el-link.el-link--default{
    color: rgb(255,255,255);
}

::v-deep  .el-row--flex{
    flex-direction: column;
}

// 移动端

::v-deep .mobie_box {
    .el-row--flex{
        flex-direction: row;
    }
    .el-submenu__title{
        font-size:26px;
        color: #000000;
        font-weight: 600;
    }
    .submenu_mb{
        font-size:26px;
        color: #5D5D5D !important;
        font-weight: 600;
    }
    .el-menu-item{
        font-size:22px;
        color: #5D5D5D;
        height: 80px !important;
        line-height: 80px !important;
    }
    .el-menu-item, .el-submenu__title{
        height:90px;
        line-height: 90px;
    }
    .el-submenu .el-menu{
        background: #edeef3;
    }
    .el-submenu__icon-arrow{
        top:40%;
        font-size:30px;
    }
}

.mobie_box{
    width: 100%;
}

.mb_col_box{
    background:#FFFFFF;
    padding:20px;
}

.mb_menu_box{
    margin-top:20%;
    margin-right:10px;
}

.mb_btn{
    font-size:14px;
    font-family: ArialMT;
}

.mb_menulist_box{
    min-height:300px;
    width: 400px;
    position: absolute;
    top:148px;
    left:0;
    z-index: 100;
}
::v-deep .el-drawer{
    padding-top:20px;
    font-family: Arial-BoldMT, Arial;
    .el-submenu__title{
        font-size:26px;
        color: #000000;
        font-weight: 600;
    }
    .submenu_mb{
        font-size:26px;
        color: #5D5D5D !important;
        font-weight: 600;
    }
    .el-menu-item{
        font-size:22px;
        color: #5D5D5D;
        height: 80px !important;
        line-height: 80px !important;
        width: 100%;   /*一定要设置宽度，或者元素内含的百分比*/
        overflow:hidden; /*溢出的部分隐藏*/
        white-space: nowrap; /*文本不换行*/
        text-overflow:ellipsis;/*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
    }
    .el-menu-item, .el-submenu__title{
        height:90px;
        line-height: 90px;
    }
    .el-submenu .el-menu{
        background: #edeef3;
    }
    .el-submenu__icon-arrow{
        top:40%;
        font-size:30px;
    }
}


.mb_btn_bg1{
    background: #1f2131;
    color:#fff;
}

.mb_btn_bg2{
    background: #fff;
    font-size:30px;
    color: #21212A;
    font-family: ArialMT;
    line-height: 28px;
}
.mb_btn_bg4{
    background: #fff;
    font-size:30px;
    color: #9899A1;
    font-family: ArialMT;
    line-height: 28px;
}
.mb_btn_bg3{
    font-size:30px;
    color: #EAEAEA;
    // transform: translateY(25px);
}

.img_box_mb{
    width: 130px;
    margin-top:10px;
    margin-left:10px;
    padding-right:20px;
    border-right: 1px solid rgba(0,0,0,0.5);
}

@media screen and (min-width: 1000px) and (max-width: 1460px){
    
    .header_box {
        width: 86%;
        .first_col_box{
            margin-right:15px;
        }
        .btn_box{
            font-size:12px;
        }
        .languch_box{
            font-size:12px;
        }
        .icon_box{
            font-size:16px;
        }
        .colMenu_box{
            font-size:12px;
        }
        .el-link{
            justify-content: left;
            font-size:12px;
        }
    }
}
@media screen and (min-width: 1460px) and (max-width: 1760px){
    
    .header_box {
        width: 85%;
        .first_col_box{
            margin-right:10px;
        }
        .btn_box{
            font-size:14px;
        }
        .languch_box{
            font-size:14px;
        }
        .icon_box{
            font-size:18px;
        }
        .colMenu_box{
            font-size:14px;
        }
        .el-link{
            justify-content: left;
            font-size:14px;
        }
    }
}
.mb_top_left_box{
    display: flex;
}
.img_box_font{
    padding-left:20px;
    padding-top:25px;
    font-size: 24px;
    font-family: ArialMT;
    color: #1F1F1F;
    line-height: 32px;
}




.bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
</style>
